import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-page lr" }
const _hoisted_2 = { class: "center-box" }

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import VueParticles from '@/components/vue-particles/vue-particles.vue';
import { doSsoLogin } from '@/utils/login';

import LoginTopbar from './components/LoginTopbar.vue';

interface INavConfig {
  href: string;
  text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const navConfig = ref<INavConfig[]>([]);

const goLogin = (type: 'cas' | 'passport') => {
  const redirect = route.query.redirect || location.origin;

  doSsoLogin(type, redirect as string);
};

// 登录页没有子项目，需要独自初始化
window.xmot?.('init', {
  appId: '31000402230',
  projectId: 'mi-retail',
  privateKey: 'e0c8a21dc4d22b6884eb9e8f348cc3416d13dfaf',
  topic:
    'ot_31000402230_' + (JSON.parse(localStorage?.getItem('regionData') || '{}')?.region || 'sg')
});
// 发动曝光埋点
window.xmot?.('view', { tip: '310.535.0.1.41540' });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VueParticles, {
      color: "#FFFFFF",
      "particle-opacity": 0.2,
      "particle-size": 2,
      "lines-color": "#FFFFFF",
      "line-opacity": 0.2,
      "move-speed": 2,
      "click-effect": false
    }),
    _createVNode(LoginTopbar, { "nav-config": navConfig.value }, null, 8, ["nav-config"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "slogan-text" }, [
        _createTextVNode("一切为了极致的"),
        _createElementVNode("br"),
        _createTextVNode("用户体验和商业效率")
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "slogan-text-en" }, " It's all about the best user experience and business efficiency ", -1)),
      _createElementVNode("button", {
        class: "login-button cas",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goLogin('passport')))
      }, "Passport登录")
    ])
  ]))
}
}

})